import { FormattedMessage } from "react-intl";
import * as Yup from "yup";

export const profileFormSchema = Yup.object().shape({
  firstName: Yup.string()
    .matches(/^\S*$/, {
      message: <FormattedMessage id="first-name-validation" />,
    })
    .matches(/^[a-zA-Z\u0600-\u06FF,-][\sa-zA-Z\u0600-\u06FF,-]*$/, {
      message: <FormattedMessage id="first-name-validation" />,
    })
    .min(2)
    .max(20),
  lastName: Yup.string()
    .matches(/^\S*$/, {
      message: <FormattedMessage id="last-name-validation" />,
    })
    .matches(/^[a-zA-Z\u0600-\u06FF,-][\sa-zA-Z\u0600-\u06FF,-]*$/, {
      message: <FormattedMessage id="last-name-validation" />,
    })
    .min(2)
    .max(20),
  phoneNumber: Yup.string()
    .matches(/^[0-9]*$/)
    .max(15, <FormattedMessage id="mobile-max-validation" />)
    .min(7, <FormattedMessage id="mobile-min-validation" />),
  address: Yup.string().required(
    <FormattedMessage id="address-required-validation" />,
  ),
  birthDate: Yup.date()
    .required(<FormattedMessage id="dob-required-validation" />)
    .min("1900-01-01", <FormattedMessage id="min-date-value" />)
    .max(
      new Date().toJSON().slice(0, 10),
      <FormattedMessage id="max-date-value" />,
    ),
});
